exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member-type-create-and-update-form__color-input {\n  width: auto;\n}\n.member-type-create-and-update-form__color-preview {\n  height: 32px;\n  width: 64px;\n  vertical-align: middle;\n  display: inline-block;\n}\n.member-type-create-and-update-form__color-presets {\n  height: 32px;\n}\n.member-type-create-and-update-form__color-presets > * {\n  height: 100%;\n  width: 32px;\n  margin-right: 8px;\n  cursor: pointer;\n  display: inline-block;\n}\n", ""]);

// exports
